export { default as AxisSolidIcon } from './AxisSolidIcon';
